import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { cancelSubscription, getBillingStats, getTransactions, stripeCheckout } from './api';
import { useParams } from 'react-router-dom';
import { BillingStatsResponse, TransactionResponse } from './types';

export function useStripeCheckout() {
  return useMutation({
    mutationFn: () => stripeCheckout()
  });
}

export function useGetTransactions(options?: UseQueryOptions<{ data: TransactionResponse[] }, Error>) {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  return useQuery<{ data: TransactionResponse[] }>({
    queryKey: ['transactions', workspaceId],
    queryFn: () => getTransactions(workspaceId!),
    enabled: Boolean(workspaceId),
    ...options
  });
}

export function useGetCancelSubscription(options?: UseQueryOptions<{ manage_url: string }, Error>) {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  return useQuery<{ manage_url: string }>({
    queryKey: ['cancelSubscription', workspaceId],
    queryFn: () => cancelSubscription(workspaceId!),
    enabled: Boolean(workspaceId),
    ...options
  });
}

export function useGetBillingStats(options?: UseQueryOptions<BillingStatsResponse, Error>) {
  return useQuery<BillingStatsResponse>({
    queryKey: ['billingStats'],
    queryFn: () => getBillingStats(),
    ...options
  });
}
